import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
// import Footer from "../../layout/Footer/Footer";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
  Badge,
} from "reactstrap";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import encode from "nodejs-base64-encode";
import axios from "axios";
import Baja from "../../Baja";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import { v4 as uuidv4 } from "uuid";
import moment from "moment";

// Fecha "AAAA-MM-DD" → "26/oct/2026"
const MESES = ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"];
const fmtFecha = (f) => {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(f || ""));
  return m ? `${m[3]}/${MESES[Number(m[2]) - 1]}/${m[1]}` : f || "";
};
// Más reciente primero
const porFechaDesc = (a, b) => (a.fecha < b.fecha ? 1 : a.fecha > b.fecha ? -1 : 0);

function EstadoCuentaMaq() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_PROVEEDORES = process.env.REACT_APP_URL_PROVEEDORES;
  
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;
  const URL_ESTADO_CUENTA = process.env.REACT_APP_URL_ESTADO_CUENTA;

let hoy = new Date();

// Primer día del año actual
let inicio = new Date(hoy.getFullYear(), 0, 1);

let endDate = moment(hoy).format("YYYY-MM-DD");
let startDate = moment(inicio).format("YYYY-MM-DD");

  const [proveedores, setProveedores] = useState([]);
 
  const [mailTo, setMailTo] = useState("");
  const [selectedArea, setSelectedArea] = useState("");
 
  const [nombreProveedor, setNombreProveedor] = useState([]);
  const [saldo, setSaldo] = useState(0);

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [modalMail2, setModalMail2] = useState(false);
  const toggleMail2 = () => setModalMail2(!modalMail2);
  const [modalMail3, setModalMail3] = useState(false);
  const toggleMail3 = () => setModalMail3(!modalMail3);
  const [modalMail4, setModalMail4] = useState(false);
  const toggleMail4 = () => setModalMail4(!modalMail4);

  const [modalEdoCta, setModalEdoCta] = useState(false);
  const toggleEdoCta = () => setModalEdoCta(!modalEdoCta);

  const [modalAgrupado, setModalAgrupado] = useState(false);
  const toggleAgrupado = () => setModalAgrupado(!modalAgrupado);

  const [activo, setActivo] = useState("");
  const [vendedor, setVendedor] = useState("");
  const [grupo, setGrupo] = useState("");

  const [selectedFechaInicio, setSelectedFechaInicio] = useState(startDate);
  const [selectedFechaFin, setSelectedFechaFin] = useState(endDate);
  const [movimientos, setMovimientos] = useState([]);
  const [entregas, setEntregas] = useState([]);
  const [cargos, setCargos] = useState([]);
  const [material, setMaterial] = useState([]);

  const [idProveedor, setIdProveedor] = useState("");
  const [saldoInicial, setSaldoInicial] = useState(0);
  const [plazo, setPlazo] = useState(0);

  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50;

  useMemo(() => {
    axios
      .get(`${URL_PROVEEDORES}Maquileros`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allProveedores = response.data;
        // Array para pagination
        let arrayTabla = allProveedores
          .sort((a, b) => (a.nombre_comercial > b.nombre_comercial ? 1 : -1))
          .map((a) => {
              return {
                _id: a._id,
                activo: a.is_active,
                nombre_comercial: a.nombre_comercial,
                cargos: parseFloat(a.cargos),
                abonos: parseFloat(a.abonos),
                saldo: parseFloat(a.saldo),
                banco: a.banco,
                clabe: a.clabe,
                beneficiario: a.beneficiario,
              };
          
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);

        setProveedores(allProveedores);
        setComments(dataFinal);
        //
      })
      .catch((err) => {
        console.log(err);
      });
  

    let SI = movimientos
      .map((c) => {
        if (selectedFechaInicio) {
          if (
            (selectedFechaInicio == "" || selectedFechaInicio > c.fecha)
          ) {
            return c.cargo - c.abono;
          }
        } else {
          return 0;
        }
      })
      .filter(function (el) {
        return el != null;
      });

    let TC = SI.reduce((t, total, index) => t + total, 0);

    setSaldoInicial(TC);
  }, [user, movimientos, selectedFechaInicio]);

  const ListaProveedores = comments.sort((a, b) =>
    a.nombre_comercial > b.nombre_comercial ? 1 : -1
  );

  function PDFTabla() {
    let totalCargos = 0;
    let totalAbonos = 0;
    let totalSaldo = 0;
    const data = ListaProveedores.map((a) => {
      if (
        (activo == 0 || activo == a.is_active)
      ) {
        return [a.nombre_comercial,
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.cargos),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.abonos),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.saldo),
          a.banco,
          a.clabe,
          a.beneficiario
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape");
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 140, 15, 25, 25);
    doc.text(`Estado de Cuenta Proveedores`, 15, 40);
    doc.autoTable({
      head: [
        [
          "Proveedor",
          "Cargos",
          "Abonos",
          "Saldo",
          "Banco",
          "Clabe",
          "Beneficiario"
        ],
      ],
      body: dataPDFLimpia,
      startY: 45,
      foot: [
        [
          "Totales",
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalCargos),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalAbonos),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalSaldo),
        ],
      ],
      showFoot: "lastPage",
    });
    doc.save(`EstadosDeCuentaProv.pdf`);
  }

  function excel() {
    const dataExcel = ListaProveedores.map((a) => {
      if (
        (activo == 0 || activo == a.is_active)
      ) {
        return {
          Proveedor: a.nombre_comercial,
          Cargos: a.cargos,
          Abonos: a.abonos,
          Saldo: a.saldo,
          Banco: a.banco,
          Clabe: a.clabe,
          Beneficiario: a.beneficiario,
        };
      }
    });
    const dataExportExcel = Object.values(dataExcel);
    const dataExcelLimpia = dataExportExcel.filter(function (el) {
      return el != null;
    });

    var option = {};

    option.fileName = "EstadoCuentaProv";

    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: "EstadoCuentaProv",
        sheetFilter: [
          "Proveedor",
          "Cargos",
          "Abonos",
          "Saldo",
          "Banco",
          "Clabe",
          "Beneficiario"
        ],
        sheetHeader: [
          "Proveedor",
          "Cargos",
          "Abonos",
          "Saldo",
          "Banco",
          "Clabe",
          "Beneficiario"
        ],
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  function enviaMail() {
    let totalCargos = 0;
    let totalAbonos = 0;
    let totalSaldo = 0;
    const data = ListaProveedores.map((a) => {
      if (
        (activo == 0 || activo == a.is_active)
      ) {
        return [a.nombre_comercial,
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.cargos),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.abonos),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.saldo),
          a.banco,
          a.clabe,
          a.beneficiario
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape");
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 140, 15, 25, 25);
    doc.text(`Estado de Cuenta Proveedores`, 15, 40);
    doc.autoTable({
      head: [
        [
          "Proveedor",
          "Cargos",
          "Abonos",
          "Saldo",
          "Banco",
          "Clabe",
          "Beneficiario"
        ],
      ],
      body: dataPDFLimpia,
      startY: 45,
      foot: [
        [
          "Totales",
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalCargos),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalAbonos),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalSaldo),
        ],
      ],
      showFoot: "lastPage",
    });
    var att = doc.output("arraybuffer");
    var base64File = encode.encode(att, "base64");

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Estado de Cuenta",
          email: mailTo,
          fileName: "EstadoCuenta.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras los saldos de los proveedores.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         <tr align="right"><br>Powered by <a href="https://lynqro.com"> <img width="20%" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}Logo-Lynqro-PDF.png" /> </a> </tr>
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
        setMailTo("");
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
        });
        console.log(error);
      });
  }

  const headers = [
    { name: "Nombre Comercial", field: "nombre_comercial", sortable: true },
    { name: "Cargos", field: "cargos", sortable: true },
    { name: "Abonos", field: "abonos", sortable: true },
    { name: "Saldo", field: "saldo", sortable: true },
    { name: "Estado Cuenta", field: "acciones", sortable: false },
  ];

  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          comment.nombre_comercial
            .toLowerCase()
            .includes(search.toLowerCase()) ||
          comment.cargos.toString().includes(search) ||
          comment.abonos.toString().includes(search) ||
          comment.saldo.toString().includes(search)
      );
    }

    if (activo) {
      computedComments = computedComments.filter((e) =>
        e.activo.includes(activo)
      );
    }
  
    setTotalItems(computedComments.length);

    //Sorting comments
    if (
      sorting.field &&
      sorting.field != "cargos" &&
      sorting.field != "abonos" &&
      sorting.field != "saldo"
    ) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    if (
      sorting.field &&
      sorting.order === "asc" &&
      (sorting.field == "cargos" ||
        sorting.field == "abonos" ||
        sorting.field == "saldo")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) > parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    if (
      sorting.field &&
      sorting.order === "desc" &&
      (sorting.field == "cargos" ||
        sorting.field == "abonos" ||
        sorting.field == "saldo")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) < parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [
    comments,
    currentPage,
    search,
    sorting,
    activo,
  ]);

async function jalaMov(id, proveedor, saldo) {
  try {
    const { data } = await axios.get(`${URL_ESTADO_CUENTA}Maq/${id}`, {
      headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
    });

    // Desestructura con defaults por si alguna llave no viene
    const {
      entregas: entregasResp = [],
      cargos: cargosResp = [],
      material: materialResp = [],
    } = data || {};

    setEntregas([...entregasResp].sort(porFechaDesc));
    setCargos([...cargosResp].sort(porFechaDesc));
    setMaterial([...materialResp].sort(porFechaDesc));

    // OPCIONAL: construir una lista combinada para mostrar todo junto
    const combinado = [
      ...entregasResp.map((x) => ({ ...x, tipo: "Entrega" })),
      ...cargosResp.map((x) => ({ ...x, tipo: "Cargo" })),
      ...materialResp.map((x) => ({ ...x, tipo: "Material" })),
    ].sort((a, b) => (a.fecha > b.fecha ? 1 : -1));

    setMovimientos(combinado);

    setNombreProveedor(proveedor);
    setIdProveedor(id);
    setSaldo(saldo);
    toggleEdoCta();
  } catch (err) {
    console.log(err);
  }
}
function PDFOC() {
  // Helpers
  const fmtUSD = (n) =>
    new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      maximumFractionDigits: 2,
    }).format(Number(n || 0));
  const fmtInt = (n) =>
    new Intl.NumberFormat("en-US", { maximumFractionDigits: 0 }).format(
      Number(n || 0)
    );

  // Documento LANDSCAPE
  const doc = new jsPDF({ unit: "mm", format: "a4", orientation: "landscape" });
  const pageW = doc.internal.pageSize.getWidth();
  const margin = 12; // margen un poco menor
  const gap = 6; // separación entre columnas

  // --- LOGO (Fratelo) arriba, pequeño ---
  try {
    const img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "PNG", pageW - margin - 24, 6, 20, 20); // pequeño y arriba
  } catch (e) {}

  // --- ENCABEZADO compacto ---
  doc.setFont("helvetica", "bold");
  doc.setFontSize(13);
  doc.text(`${nombreProveedor || ""}`, margin, 14);

  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text(`Desde: ${selectedFechaInicio || ""}`, margin, 20);

  // --- “Tarjetas” SIN recuadro (compactas) ---
  // Configuración compacta
  const startY = 28; // arrancamos más arriba para dejar más espacio a la tabla
  const cols = 3;
  const innerW = pageW - 2 * margin - (cols - 1) * gap;
  const colW = innerW / cols;
  const titleGap = 5; // espacio vertical del título
  const rowH = 4.5; // altura de renglón compacta
  const labelOffsetX = 2.5; // sangría de etiqueta
  const valueOffsetX = 2.5; // sangría derecha para valor

  // Título de columna (texto simple, sin recuadro)
  const drawColTitle = (title, x, y) => {
    doc.setFont("helvetica", "bold");
    doc.setFontSize(11);
    doc.text(title, x, y);
  };

  // Renglón etiqueta-valor
  const drawRow = (label, value, x, y) => {
    doc.setFont("helvetica", "normal");
    doc.setFontSize(9.5);
    doc.text(label, x + labelOffsetX, y);
    doc.text(value, x + colW - valueOffsetX, y, { align: "right" });
    return y + rowH;
  };

  // Columna 1: Importes del periodo
  const x1 = margin;
  let y1 = startY;
  drawColTitle("Importes del periodo", x1, y1);
  y1 += titleGap;
  y1 = drawRow("Saldo Anterior", fmtUSD(saldoAnterior), x1, y1);
  y1 = drawRow("Total Cargos", fmtUSD(totalCargosImporte), x1, y1);
  y1 = drawRow("Total Material Aplicado", fmtUSD(totalMaterialAplicado), x1, y1);
  // y1 = drawRow("Total Material", fmtUSD(totalMaterialImporte), x1, y1);
  y1 = drawRow("Total Entregas", fmtUSD(totalEntregasImporte), x1, y1);

  // separador discreto
  doc.setDrawColor(200);
  doc.line(x1 + 1.5, y1 - rowH / 2 + 0.5, x1 + colW - 1.5, y1 - rowH / 2 + 0.5);
  doc.setDrawColor(0);

  // Saldo en negritas
  doc.setFont("helvetica", "bold");
  doc.setFontSize(10);
  y1 = drawRow("Saldo", fmtUSD(saldoPeriodo), x1, y1 + 1.5);
  doc.setFont("helvetica", "normal");

  // Columna 2: Año Anterior
  const x2 = x1 + colW + gap;
  let y2 = startY;
  drawColTitle("Año Anterior", x2, y2);
  y2 += titleGap;
  y2 = drawRow(
    "Entregas",
    fmtInt(entregasCantidadAntes),
    x2,
    y2
  );
  y2 = drawRow("Promedio mensual", fmtInt(promMensualAntes), x2, y2);

  // Columna 3: Año Actual
  const x3 = x2 + colW + gap;
  let y3 = startY;
  drawColTitle("Año Actual", x3, y3);
  y3 += titleGap;
  y3 = drawRow(
    "Entregas",
    fmtInt(entregasCantidadActual),
    x3,
    y3
  );
  y3 = drawRow("Promedio mensual", fmtInt(promMensualActual), x3, y3);

// --- Punto de inicio para la(s) tabla(s) ---
const nextStartY = Math.max(y1, y2, y3) + 4;

// ====== Métricas horizontales (ya las tenías) ======
const totalUnits = 12;
const units = [3, 5, 4]; // Cargos, Material, Entregas
const tInnerW = pageW - 2 * margin - 2 * gap;
const tW1 = (units[0] / totalUnits) * tInnerW;
const tW2 = (units[1] / totalUnits) * tInnerW;
const tW3 = (units[2] / totalUnits) * tInnerW;

const tX1 = margin;
const tX2 = tX1 + tW1 + gap;
const tX3 = tX2 + tW2 + gap;

  // ---------- CARGOS ----------
  const cargosBody = (cargosFiltrados ?? []).map((x) => [
    fmtFecha(x.fecha),
    x.concepto ?? "",
    fmtUSD(x.importe || 0),
    x.observaciones ?? "",
  ]);

  // Fuerza a arrancar en página 1
doc.setPage(1);
doc.setFont("helvetica", "bold");
doc.setFontSize(10);
doc.text("Cargos", tX1, nextStartY - 2);

  doc.autoTable({
    startY: nextStartY,
  margin: { left: tX1 },
  tableWidth: tW1,
  // ¡NO uses pageBreak:"avoid"!
  styles: { font: "helvetica", fontSize: 6, cellPadding: 1.2, overflow: "linebreak", lineWidth: 0.1 },
  headStyles: { fontStyle: "bold", fontSize: 6, halign: "center" },
  bodyStyles: { fontSize: 6 },
  footStyles: { fontSize: 6 },
  columnStyles: { 0:{halign:"center"}, 1:{halign:"center"}, 2:{halign:"right"} },
  head: [[ "Fecha", "Concepto", "Importe", "Observaciones" ]],
  body: cargosBody,
  foot: [[ "", { content: "Total", styles: { halign: "right", fontStyle: "bold" } }, { content: fmtUSD(totalCargosImporte || 0), styles: { halign: "right", fontStyle: "bold" } }]],
  });

  // ---------- MATERIAL ----------
  const materialFiltrado = (material ?? []).filter(
  (x) => !selectedFechaInicio || selectedFechaInicio <= x.fecha
);
const materialBody = materialFiltrado.map((x) => [
  fmtFecha(x.fecha),
  x.modelo ?? "",
  x.OP ?? "",
  x.cantidad ?? "",
  fmtUSD(x.importe || 0),
  fmtUSD(x.aplicado || 0),
  fmtUSD(x.porAplicar || 0),
]);

doc.setPage(1);
doc.setFont("helvetica", "bold");
doc.setFontSize(10);
doc.text("Material", tX2, nextStartY - 2);

doc.autoTable({
  startY: nextStartY,
  margin: { left: tX2 },
  tableWidth: tW2,
  styles: { font: "helvetica", fontSize: 6, cellPadding: 1.2, overflow: "linebreak", lineWidth: 0.1 },
  headStyles: { fontStyle: "bold", fontSize: 6, halign: "center" },
  bodyStyles: { fontSize: 6 },
  footStyles: { fontSize: 6 },
  columnStyles: {
    0:{halign:"center"}, 1:{halign:"left"}, 2:{halign:"center"},
    3:{halign:"right"}, 4:{halign:"right"}, 5:{halign:"right"}, 6:{halign:"right"},
  },
  head: [[ "Fecha", "Modelo", "OP", "Cant.", "Importe", "Aplicado", "Por Aplicar" ]],
  body: materialBody,
  foot: [[
    { content: "Totales", colSpan: 4, styles: { halign: "right", fontStyle: "bold" } },
    { content: fmtUSD(totalMaterialImporte || 0), styles: { halign: "right", fontStyle: "bold" } },
    { content: fmtUSD(totalMaterialAplicado || 0), styles: { halign: "right", fontStyle: "bold" } },
    { content: fmtUSD(totalMaterialPorAplicar || 0), styles: { halign: "right", fontStyle: "bold" } },
  ]],
});


  // ---------- ENTREGAS ----------
const entregasFiltrado = (entregas ?? []).filter(
  (x) => !selectedFechaInicio || selectedFechaInicio <= x.fecha
);
const entregasBody = entregasFiltrado.map((x) => [
  fmtFecha(x.fecha),
  x.modelo ?? "",
  x.OP ?? "",
  x.cantidad ?? "",
  fmtUSD(x.precio || 0),
  fmtUSD(x.total || 0),
]);

doc.setPage(1);
doc.setFont("helvetica", "bold");
doc.setFontSize(10);
doc.text("Entregas", tX3, nextStartY - 2);

doc.autoTable({
  startY: nextStartY,
  margin: { left: tX3 },
  tableWidth: tW3,
  styles: { font: "helvetica", fontSize: 6, cellPadding: 1.2, overflow: "linebreak", lineWidth: 0.1 },
  headStyles: { fontStyle: "bold", fontSize: 6, halign: "center" },
  bodyStyles: { fontSize: 6 },
  footStyles: { fontSize: 6 },
  columnStyles: {
    0:{halign:"center"}, 1:{halign:"left"}, 2:{halign:"center"},
    3:{halign:"right"}, 4:{halign:"right"}, 5:{halign:"right"},
  },
  head: [[ "Fecha", "Modelo", "OP", "Cant.", "Precio", "Total" ]],
  body: entregasBody,
  foot: [[
    { content: "", colSpan: 3 },
    { content: (totalEntregasCantidad ?? 0).toString(), styles: { halign: "right", fontStyle: "bold" } },
    { content: "Total", styles: { halign: "right", fontStyle: "bold" } },
    { content: fmtUSD(totalEntregasImporte || 0), styles: { halign: "right", fontStyle: "bold" } },
  ]],
});

  // Vista previa
  // window.open(doc.output("bloburl"), "_blank");
  doc.save(`EdoCtaProveedor-${(nombreProveedor || "").replace(/\s+/g, "_")}.pdf`);
}



  function emailFOC() {
    let saldoParcial = saldoInicial;
    let totalCargosEdoCte = 0;
    let totalAbonosEdoCte = 0;
    let totalSaldoEdoCte = 0;

    const data = movimientos.map((a) => {
      if (
        (selectedFechaInicio == "" || selectedFechaInicio <= a.fecha)
      ) {
        totalCargosEdoCte = totalCargosEdoCte + a.cargo;
        totalAbonosEdoCte = totalAbonosEdoCte + a.abono;
        totalSaldoEdoCte = totalCargosEdoCte - totalAbonosEdo;
        saldoParcial = saldoParcial + a.cargo - a.abono;
        const cargos = new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.cargo);
        const abonos = new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.abono);
        var saldoParcialFormato =
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(saldoParcial);
        return [
          a.fecha,
          a.movimiento,
          a.numero,
          cargos,
          abonos,
          saldoParcialFormato,
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF();
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 150, 10, 33, 10);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 160, 23, 25, 25);
    // doc.setFontSize(14)
    doc.text(`Estado de Cuenta`, 15, 30);
    doc.text(`Proveedor ${nombreProveedor}`, 15, 37);
    doc.text(`Desde ${selectedFechaInicio}`, 15, 44);
    doc.autoTable({
      head: [
        [
          "Fecha",
          "Movimiento",
          "Numero",
          "Cargos",
          "Abonos",
          "Saldo",
        ],
      ],
      body: dataPDFLimpia,
      startY: 50,
      foot: [
        [
          "",
          "",
          "",
          { content: "Saldo Anterior", colSpan: 2, styles: { halign: "left" } },
          // "Saldo Anterior",
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(saldoInicial),
        ],
        [
          "",
          "",
          "",
          {
            content: "Cargos del Periodo",
            colSpan: 2,
            styles: { halign: "left" },
          },
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalCargosEdoCte),
        ],
        [
          "",
          "",
          "",
          {
            content: "Abonos del Periodo",
            colSpan: 2,
            styles: { halign: "left" },
          },
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalAbonosEdoCte),
        ],
        [
          "",
          "",
          "",
          { content: "Saldo Actual", colSpan: 2, styles: { halign: "left" } },
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(saldoParcial),
        ],
      ],
      showFoot: "lastPage",
    });
    var att = doc.output("arraybuffer");
    var base64File = encode.encode(att, "base64");

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Estado de Cuenta",
          email: mailTo,
          fileName: `EstadoCuenta-${nombreProveedor}.pdf`,
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras el Estado de Cuenta de ${nombreProveedor}.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         <tr align="right"><br>Powered by <a href="https://lynqro.com"> <img width="20%" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}Logo-Lynqro-PDF.png" /> </a> </tr>
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail2();
        Swal.fire("Good job!", "Enviado con exito", "success");
        setMailTo("");
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
        });
        console.log(error);
      });
  }

  function excelFOC() {
    const dataExcel = movimientos.map((a) => {
      if (
        (selectedFechaInicio == "" || selectedFechaInicio <= a.fecha)
      ) {
        return {
          Fecha: a.fecha,
          Movimiento: a.movimiento,
          Numero: a.numero,
          Cargo: a.cargo,
          Abono: a.abono,
          Cargos: a.cargos,
        };
      }
    });
    const dataExportExcel = Object.values(dataExcel);
    const dataExcelLimpia = dataExportExcel.filter(function (el) {
      return el != null;
    });

    var option = {};

    option.fileName = `EdoCtaProveedor-${nombreProveedor}`;

    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: "EstadoCuentaProv",
        sheetFilter: [
          "Fecha",
          "Movimiento",
          "Numero",
          "Cargo",
          "Abono",
        ],
        sheetHeader: [
          "Fecha",
          "Movimiento",
          "Numero",
          "Cargo",
          "Abono",
        ],
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  
  let totalCargosTabla = 0;
  let totalAbonosTabla = 0;
  let totalSaldoTabla = 0;

  let saldoParcialTabla = saldoInicial;
  let totalCargosEdo = 0;
  let totalAbonosEdo = 0;
  let totalSaldoEdo = 0;

  const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
  const secondDate = new Date(hoy);
  let saldoVencido =0

  // ===== Helpers =====
const fmtUSD = (n=0) =>
  new Intl.NumberFormat("en-US", { style:"currency", currency:"USD", maximumFractionDigits:2 })
    .format(Number(n)||0);
const fmtInt = (n=0) =>
  new Intl.NumberFormat("en-US", { maximumFractionDigits:0 })
    .format(Number(n)||0);

// Normaliza fecha a YYYY-MM-DD
const asYMD = (s) => {
  if (typeof s === "string" && /^\d{4}-\d{2}-\d{2}/.test(s)) return s.slice(0,10);
  const d = new Date(s);
  return isNaN(d.getTime()) ? "" : d.toISOString().slice(0,10);
};

const hasStart       = !!selectedFechaInicio;
const isBeforeStart  = (f) => hasStart && asYMD(f) <  selectedFechaInicio;
const isOnOrAfter    = (f) => !hasStart || asYMD(f) >= selectedFechaInicio;

// ===== Listas para tablas (>= fecha seleccionada) =====
const cargosFiltrados    = cargos.filter(x   => isOnOrAfter(x.fecha));
const materialFiltrados  = material.filter(x => isOnOrAfter(x.fecha));
const entregasFiltradas  = entregas.filter(x => isOnOrAfter(x.fecha));

// Totales mostrados en <tfoot> de cada tabla
const totalCargosImporte      = cargosFiltrados.reduce((t,a)=> t + (Number(a.importe)||0), 0);

const totalMaterialImporte    = materialFiltrados.reduce((t,a)=> t + (Number(a.importe)||0), 0);
const totalMaterialAplicado   = materialFiltrados.reduce((t,a)=> t + (Number(a.aplicado)||0), 0);
const totalMaterialPorAplicar = materialFiltrados.reduce((t,a)=> t + (Number(a.porAplicar)||0), 0);

const totalEntregasCantidad   = entregasFiltradas.reduce((t,a)=> t + (Number(a.cantidad)||0), 0);
const totalEntregasImporte    = entregasFiltradas.reduce((t,a)=> t + (Number(a.total)||0), 0);

// ===== Saldos (por si también los usas arriba) =====
// ANTES de la fecha seleccionada
const totalCargosAntes            = cargos.filter(x => isBeforeStart(x.fecha))
  .reduce((t,a)=> t + (Number(a.importe)||0), 0);
// Solo el material aplicado (igual que en el periodo y en el saldo del maquilero)
const totalMaterialAntes          = material.filter(x => isBeforeStart(x.fecha))
  .reduce((t,a)=> t + (Number(a.aplicado)||0), 0);
const totalEntregasAntesImporte   = entregas.filter(x => isBeforeStart(x.fecha))
  .reduce((t,a)=> t + (Number(a.total)||0), 0);
const saldoAnterior               = totalEntregasAntesImporte - totalMaterialAntes - totalCargosAntes;

// Cantidades “año anterior/actual” (si las usas)
const entregasCantidadAntes  = entregas.filter(x => isBeforeStart(x.fecha))
  .reduce((t,a)=> t + (Number(a.cantidad)||0), 0);
const entregasCantidadActual = entregasFiltradas.reduce((t,a)=> t + (Number(a.cantidad)||0), 0);
// Calcular meses finalizados desde la fecha de inicio hasta HOY
const getFinishedMonths = (start, today = new Date()) => {
  const s = new Date(asYMD(start)); // normaliza a YYYY-MM-DD
  // último día del mes anterior a 'today'
  const lastCompleted = new Date(today.getFullYear(), today.getMonth(), 0);

  // si el inicio es después del último mes completo, no hay meses finalizados
  if (s > lastCompleted) return 0;

  // meses inclusivos: desde el mes de 's' hasta 'lastCompleted'
  const months =
    (lastCompleted.getFullYear() - s.getFullYear()) * 12 +
    (lastCompleted.getMonth() - s.getMonth()) 
    // + 1;

  return months;
};


const mesesFinalizados = getFinishedMonths(selectedFechaInicio, new Date());

// Promedios
const promMensualAntes  = entregasCantidadAntes / 12; // si quieres lo mismo aquí puedes aplicar la misma lógica
const promMensualActual = mesesFinalizados === 0
  ? 0
  : (entregasCantidadActual / mesesFinalizados);
console.log("hola", mesesFinalizados)

// Saldo del periodo (>= fecha)
const saldoPeriodo = saldoAnterior + totalEntregasImporte - totalMaterialAplicado - totalCargosImporte;


  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_adminCxP ? (
        <div className="card col-12">
          <Row>
            <Col md={8}>
              <Button
                size="sm"
                href="/MenuCXP"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
            </Col>
            <Col sm={4}>
              <ButtonGroup id="logoutBoton">
                <Button
                  size="sm"
                  className="btn"
                  color="danger"
                  onClick={PDFTabla}
                >
                  PDF <i class="far fa-file-pdf"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  onClick={toggleMail}
                  color="info"
                >
                  eMail <i class="fas fa-at"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  color="primary"
                  onClick={excel}
                >
                  Excel <i class="far fa-file-excel"></i>
                </Button>
              </ButtonGroup>
            </Col>
          </Row>

          <h3 align="center">Estado Cuenta Maquileros</h3>
          <div className="row">
            <div className="col-md-8">
              <Pagination
                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div>
            <div className="col-md-4 d-flex flex-row-reverse">
              <Search
                onSearch={(value) => {
                  setSearch(value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>
          <Row>
           
            <Col md={2}>
              <Label>Activo</Label>
              <Input
                bsSize="sm"
                type="select"
                value={activo}
                required
                onChange={(e) => {
                  setActivo(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="">Selecciona</option>
                <option value="Si">Activos</option>
                <option value="No">Inactivos</option>
              </Input>
            </Col>
          </Row>
          <br />
          <Table size="sm" striped borderless className="table-responsive-xl">
            <TableHeader
              headers={headers}
              onSorting={(field, order) => setSorting({ field, order })}
            />
            <tbody>
              {commentsData.map((p) => {
                totalCargosTabla = totalCargosTabla + parseFloat(p.cargos);
                totalAbonosTabla = totalAbonosTabla + parseFloat(p.abonos);
                totalSaldoTabla = totalSaldoTabla + parseFloat(p.saldo);
                {
                  return (
                    <tr>
                      <td> {p.nombre_comercial}</td>
                      <td>
                        {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(p.cargos)}
                      </td>
                      <td>
                        {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(p.abonos)}
                      </td>
                      <td>
                        {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(p.saldo)}
                      </td>
                      <td>
                        <>
                        <Button
                          color="info"
                          size="sm"
                          onClick={(e) =>
                            jalaMov(p._id, p.nombre_comercial, p.saldo)
                          }
                          id="Detalle"
                        >
                          <i class="fas fa-file-alt"></i>
                        </Button>
                        </>
                      </td>
                    </tr>
                  );
                }
              })}
              <tr>
                <td className="negrita" align="right">
                  Totales
                </td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalCargosTabla)}
                </td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalAbonosTabla)}
                </td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalSaldoTabla)}
                </td>
                <td></td>
              </tr>
            </tbody>
          </Table>
          <div className="col-md-6">
            <Pagination
              total={totalItems}
              itemsPerPage={ITEMS_PER_PAGE}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>
        </div>
      ) : undefined}
      <br />

      <Modal size="xxl" isOpen={modalEdoCta} toggle={toggleEdoCta}>
        <ModalHeader toggle={toggleEdoCta}>
          <h4>Estado de Cuenta de {nombreProveedor}</h4>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col sm={3}>
              <ButtonGroup>
                <Button
                  size="sm"
                  className="btn"
                  color="danger"
                  onClick={PDFOC}
                >
                  PDF <i class="far fa-file-pdf"></i>
                </Button>
              </ButtonGroup>
              <div className="d-flex align-items-center">
    <Label className="mr-2 mb-0">Fecha</Label>
    <Input
      bsSize="sm"
      type="date"
      value={selectedFechaInicio}
      required
      onChange={(e) => setSelectedFechaInicio(e.target.value)}
    />
  </div>
            </Col>
</Row>
<br />
<Row className="mb-3">
  {/* Columna 1: Importes del periodo */}
  <Col md={4}>
    <div className="card p-3 h-100">
      <h6 className="mb-3 text-center">Importes del periodo</h6>

      <Row>
        <Col>Saldo Anterior</Col>
        <Col className="text-end">
          {fmtUSD(saldoAnterior)}
        </Col>
      </Row>
      <Row>
        <Col>Total Cargos</Col>
        <Col className="text-end">
          {fmtUSD(totalCargosImporte)}
        </Col>
      </Row>
      <Row>
        {/* <Col>Total Material</Col>
        <Col className="text-end">
          {fmtUSD(totalMaterialImporte)}
        </Col> */}
        <Col>Total Material Aplicado</Col>
        <Col className="text-end">
          {fmtUSD(totalMaterialAplicado)}
        </Col>
      </Row>
      <Row>
        <Col>Total Entregas</Col>
        <Col className="text-end">
          {fmtUSD(totalEntregasImporte)}
        </Col>
      </Row>

      <hr className="my-2" />

      <Row>
        <Col><strong>Saldo</strong></Col>
        <Col className="text-end">
          {fmtUSD(saldoPeriodo)}
        </Col>
      </Row>
    </div>
  </Col>

  {/* Columna 2: Año Anterior */}
  <Col md={4}>
    <div className="card p-3 h-100">
      <h6 className="mb-3 text-center">Año Anterior</h6>

      <Row>
        <Col>Entregas</Col>
        <Col className="text-end">
          {fmtInt(entregasCantidadAntes)}
        </Col>
      </Row>
      <Row>
        <Col>Promedio mensual</Col>
        <Col className="text-end">
          {fmtInt(promMensualAntes)}
        </Col>
      </Row>
    </div>
  </Col>

  {/* Columna 3: Año Actual */}
  <Col md={4}>
    <div className="card p-3 h-100">
      <h6 className="mb-3 text-center">Año Actual</h6>

      <Row>
        <Col>Entregas</Col>
        <Col className="text-end">
          {fmtInt(entregasCantidadActual)}
        </Col>
      </Row>
      <Row>
        <Col>Promedio mensual</Col>
        <Col className="text-end">
          {fmtInt(promMensualActual)}
        </Col>
      </Row>
    </div>
  </Col>
</Row>

<Row className="g-3 text-small" >
  {/* CARGOS */}
 <Col md={3}>
            <div className="card p-2 h-100">
              <h6 className="mb-2" align="center">Cargos</h6>
              <div className="table-responsive">
                <Table size="sm" striped borderless>
                  <thead>
                    <tr align="center">
              <th className="tituloTabla">Fecha</th>
              <th className="tituloTabla">Concepto</th>
              <th className="tituloTabla">Importe</th>
              <th className="tituloTabla">Observaciones</th>
            </tr>
                  </thead>
                  <tbody>
                    {cargosFiltrados.map((x,i)=>(
                      <tr key={i}>
                        <td align="center">{fmtFecha(x.fecha)}</td>
                        <td align="center">{x.concepto}</td>
                        <td align="right">{fmtUSD(x.importe)}</td>
                        <td align="center">{x.observaciones}</td>
                      </tr>
                    ))}
                  </tbody>
                    <tr>
                      <td></td>
                      <td className="negrita" align="right">Total</td>
                      <td className="negrita" align="right"><strong>{fmtUSD(totalCargosImporte)}</strong></td>
                      <td></td>
                    </tr>
                </Table>
              </div>
            </div>
          </Col>


  {/* MATERIAL */}
  <Col md={5}>
    <div className="card p-2 h-100">
      <h6 className="mb-2" align="center">Material</h6>
      <div className="table-responsive">
        <Table size="sm" striped borderless>
          <thead>
            <tr align="center">
              <th className="tituloTabla">Fecha</th>
              <th className="tituloTabla">Modelo</th>
              <th className="tituloTabla">OP</th>
              <th className="tituloTabla">Cant.</th>
              <th className="tituloTabla">Importe</th>
              <th className="tituloTabla">Aplicado</th>
              <th className="tituloTabla">Por Aplicar</th>
            </tr>
          </thead>
          <tbody>
            {material
              .filter((x) => !selectedFechaInicio || selectedFechaInicio <= x.fecha)
              .map((x, i) => (
                <tr key={i}>
                  <td align="center">{fmtFecha(x.fecha)}</td>
                  <td align="left">{x.modelo}</td>
                  <td align="center">{x.OP}</td>
                  <td align="right">{x.cantidad ?? ""}</td>
                  <td align="right">
                    {new Intl.NumberFormat("en-US", {
                      style: "currency",
                      currency: "USD",
                      maximumFractionDigits: 2,
                    }).format(x.importe || 0)}
                  </td>
                  <td align="right">
                    {new Intl.NumberFormat("en-US", {
                      style: "currency",
                      currency: "USD",
                      maximumFractionDigits: 2,
                    }).format(x.aplicado || 0)}
                  </td>
                  <td align="right">
                    {new Intl.NumberFormat("en-US", {
                      style: "currency",
                      currency: "USD",
                      maximumFractionDigits: 2,
                    }).format(x.porAplicar || 0)}
                  </td>
                </tr>
              ))}
          </tbody>
  <tr>
    <td colSpan={3} className="negrita" align="right">Totales</td>
    <td className="negrita" align="right">{/* cantidad no la pediste sumar aquí */}</td>
    <td className="negrita" align="right">{fmtUSD(totalMaterialImporte)}</td>
    <td className="negrita" align="right">{fmtUSD(totalMaterialAplicado)}</td>
    <td className="negrita" align="right">{fmtUSD(totalMaterialPorAplicar)}</td>
  </tr>
        </Table>
      </div>
    </div>
  </Col>

  {/* ENTREGAS */}
  <Col md={4}>
    <div className="card p-2 h-100">
      <h6 className="mb-2" align="center">Entregas</h6>
      <div className="table-responsive">
        <Table size="sm" striped borderless>
          <thead>
            <tr align="center">
              <th className="tituloTabla">Fecha</th>
              <th className="tituloTabla">Modelo</th>
              <th className="tituloTabla">OP</th>
              <th className="tituloTabla">Cant.</th>
              <th className="tituloTabla">Precio</th>
              <th className="tituloTabla">Total</th>
            </tr>
          </thead>
          <tbody>
            {entregas
              .filter((x) => !selectedFechaInicio || selectedFechaInicio <= x.fecha)
              .map((x, i) => (
                <tr key={i}>
                  <td align="center">{fmtFecha(x.fecha)}</td>
                  <td align="left">{x.modelo}</td>
                  <td align="center">{x.OP}</td>
                  <td align="right">{x.cantidad}</td>
                  <td align="right">
                    {new Intl.NumberFormat("en-US", {
                      style: "currency",
                      currency: "USD",
                      maximumFractionDigits: 2,
                    }).format(x.precio || 0)}
                  </td>
                  <td align="right">
                    {new Intl.NumberFormat("en-US", {
                      style: "currency",
                      currency: "USD",
                      maximumFractionDigits: 2,
                    }).format(x.total || 0)}
                  </td>
                </tr>
              ))}
          </tbody>
  <tr>
    <td colSpan={3}></td>
    <td className="negrita" align="right">{totalEntregasCantidad}</td>
    <td className="negrita" align="right">Total</td>
    <td className="negrita" align="right">{fmtUSD(totalEntregasImporte)}</td>
  </tr>

        </Table>
      </div>
    </div>
  </Col>
</Row>

        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={toggleEdoCta}>
            Cerrar
          </Button>
        </ModalFooter>
      </Modal>

       <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
        <ModalHeader toggle={toggleMail}>
          <h4>Enviar Estado de Cuenta</h4>
        </ModalHeader>
        <ModalBody>
          <Label className="mr-sm-2">Email</Label>
          <Input
            className="col-sm-12"
            type="text"
            value={mailTo}
            required
            onChange={(e) => {
              setMailTo(e.target.value);
            }}
          />
        </ModalBody>
        <ModalFooter>
          <Button size="sm" color="success" onClick={enviaMail}>
            Enviar
          </Button>
        </ModalFooter>
      </Modal>
      <Modal size="sm" isOpen={modalMail2} toggle={toggleMail2}>
        <ModalHeader toggle={toggleMail2}>
          <h4>Enviar Estado de Cuenta</h4>
        </ModalHeader>
        <ModalBody>
          <Label className="mr-sm-2">Email</Label>
          <Input
            className="col-sm-12"
            type="text"
            value={mailTo}
            required
            onChange={(e) => {
              setMailTo(e.target.value);
            }}
          />
        </ModalBody>
        <ModalFooter>
          <Button size="sm" color="success" onClick={emailFOC}>
            Enviar
          </Button>
        </ModalFooter>
      </Modal>

      {loader}
    </>
  );
}

export default EstadoCuentaMaq;
